"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _two = _interopRequireDefault(require("@/components/upload/two.vue"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'deviceTypes',
  components: {
    upload: _two.default,
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      list: [],
      listQuery: {
        page: 1,
        page_num: 1,
        limit: 20
      },
      editDialog: false,
      editForm: {},
      editInfo: {
        support_buletooth: 0
      }
    };
  },
  computed: {
    deviceNameObj: function deviceNameObj() {
      return this.$store.state.user.deviceNameObj;
    }
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this = this;
      this.$get('agentapi/goods/goods_detail_types').then(function (res) {
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      });
    },
    /**
     * 修改模板ID
     */
    editID: function editID() {
      var _this2 = this;
      var params = this.editForm;
      params.depend_type = 1;
      // 【操作埋点】2026-05-25 pc_setting_update_1 编辑设备类型
      this.$post('agentapi/goods/save_goods_detail_type', params).then(function (res) {
        _this2.$settingReport.reportSettingUpdate('save_goods_detail_type', "\u8BBE\u5907\u7C7B\u578B\u300C".concat(params.type_name || '', "\u300D"), null, {
          type_name: params.type_name,
          support_buletooth: params.support_buletooth,
          music_link: params.music_link,
          zfb_music_link: params.zfb_music_link
        });
        _this2.editDialog = false;
        _this2.$message({
          message: '设置成功',
          type: 'success'
        });
        _this2.getList();
      });
    }
  }
};